import React, { useEffect } from 'react';
//style
import styles from 'src/asset/scss/style/user.mypage.module.scss';
//select
import SelectSearch from 'react-select-search';
import 'src/asset/scss/plugin/select.scss';
//store
import usePartnerStore from 'src/webapp/stores/partner.store';
//hook
import useMypageHook from 'src/webapp/hooks/mypage/mypage.hook';
//comp
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트

export default function ProfileUpdate(props) {
    const { isOpen } = props;//props
    const { info } = usePartnerStore();
    const { setMechanicOptionHandler, mechanicList//정비인원수 셋팅
		, isDisabled, onValidHandler//회원정보수정 버튼활성화여부
        , inputRef, partnerUpdateAPI//회원정보수정
	} = useMypageHook();

    /* =============== 정비인원수 셋팅 =============== */    
    useEffect(() => {
        if(!isOpen) { return; }

        setMechanicOptionHandler();
    }, [isOpen]);
    /* =============== 정비인원수 셋팅 =============== */    
    /* =============== 회원정보변경 =============== */
	const onUpdateHandler = async() => {
		const result = await partnerUpdateAPI();
		if(result) { props.onDismiss(false); }
	}
	/* =============== 회원정보변경 =============== */

    return (
        <div className={styles.partnerContainer}>
            <Element tag={`div`} className={styles.imgArea}><img src={`${process.env.REACT_APP_IMAGE_URL + info.IMG_SRC}`} alt={info.PARTNER_NAME} /></Element>
            <div className={styles.partnerUpdateContainer}>
                <div className={styles.btnArea}>
                    <button onClick={(e) => props.onDismiss(false)} className={styles.btnCancel}>취소</button>
                    <button onClick={(e) => onUpdateHandler()} disabled={isDisabled} className={styles.btnSubmit}>확인</button>
                </div>
                <div className={styles.inputContainer}>
                    <div>
                        <label>정비소명</label>
                        <input ref={el => (inputRef.current[0] = el)}
                            onChange={(e) => onValidHandler()}
                            defaultValue={info.PARTNER_NAME}
                            type='text' placeholder={`정비소명을 입력해주세요`} />
                    </div>
                    <div>
                        <label>정비인원</label>
                        <div className={['selectSearch', 'darkSelectContainer'].join(' ')}>
                            <SelectSearch ref={el => (inputRef.current[1] = el)}
                                onChange={(e) => {(inputRef.current[1].value = e); onValidHandler()}}
                                options={mechanicList} defaultValue={info.MECHANIC} />
                        </div>
                    </div>
                    <div>
                        <label>소개글</label>
                        <textarea ref={el => (inputRef.current[2] = el)}
                            onChange={(e) => onValidHandler()}
                            defaultValue={info.SUMMARY} 
                            placeholder={`소개글을 입력해주세요`} maxLength={500}></textarea>
                    </div>
                </div>
            </div>
        </div>
    );
}